module.exports = __webpack_public_path__ + "57bcb112574d914137b8322953a97380.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/pinta pora.png
// module id = 618
// module chunks = 0